export const dragAndDropStyle = {
  padding: 12,
  backgroundColor: '#F7F8FB',
  border: '1px solid #DADADA',
  width: '317px',
  height: '576px',
  gap: '8px',
  overflowX: 'auto',
  overflowY: 'auto',
};
